import { Injectable } from '@angular/core';
import {
  isRoleId,
  ROLE_CAPABILITIES,
  RoleCapabilities,
  RoleId,
} from '../models/role.model';

@Injectable({ providedIn: 'root' })
export class RoleService {
  getRoleId(): RoleId | null {
    const roleId = localStorage.getItem('roleId');
    return isRoleId(roleId) ? roleId : null;
  }

  getCapabilities(): RoleCapabilities {
    const roleId = this.getRoleId();
    return roleId
      ? ROLE_CAPABILITIES[roleId]
      : { view: false, bid: false, load: false, manage: false };
  }

  canView(): boolean {
    return this.getCapabilities().view;
  }

  canBid(): boolean {
    return this.getCapabilities().bid;
  }

  canLoad(): boolean {
    return this.getCapabilities().load;
  }

  canManage(): boolean {
    return this.getCapabilities().manage;
  }
}
